import { render, staticRenderFns } from "./bsite_bStore_deals.vue?vue&type=template&id=be02d496&scoped=true"
import script from "./bsite_bStore_deals.vue?vue&type=script&lang=js"
export * from "./bsite_bStore_deals.vue?vue&type=script&lang=js"
import style0 from "./bsite_bStore_deals.vue?vue&type=style&index=0&id=be02d496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be02d496",
  null
  
)

export default component.exports